import React, { useState, useEffect } from "react";
import PageHeader from "../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../components/reusable/ModuleHeader/Breadcrumb";
import BadgesSplitView from "../components/reusable/Navigation/BadgesSplitView";
import Button from "../components/reusable/Forms/Button";
import Tag from "../components/reusable/Information/Tag";
import Switch from "../components/reusable/Forms/Switch";
import { API_ROUTES } from "../config/api";
import{apiFetch} from "../config/apiFetch";

// ================================================================
// 🔹 Composant principal : Gestion du profil utilisateur
// ================================================================
const ProfilSubpage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ================================================================
  // Chargement initial depuis l’API
  // ================================================================
 useEffect(() => {
  const load = async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await apiFetch(API_ROUTES.users.getAll);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      setUsers(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  load();
}, []);
  // ================================================================
  // Rendu principal
  // ================================================================
  return (
    <div style={{ padding: 30 }}>
      <Breadcrumb items={[{ label: "Profil", href: "/" }]} />
      <PageHeader
        title="Profil utilisateur"
        subtitle="Paramétrage du profil utilisateur"
      />
      <hr className="page-separator" />

      {loading && <p>Chargement...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* Exemple : affichage simple */}
      <ul>
        {users.map((u) => (
          <li key={u.id}>{u.firstName} {u.lastName}</li>
        ))}
      </ul>
    </div>
  );
};

export default ProfilSubpage;
